import { Film, Eye } from 'lucide-react';

interface RecentMemory {
  slug: string;
  status: string;
  created_at: string;
  client_name: string | null;
  video_views: number;
}

interface ActivityFeedProps {
  memories: RecentMemory[];
}

function formatRelativeTime(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Ahora';
  if (diffMins < 60) return `hace ${diffMins} min`;
  if (diffHours < 24) return `hace ${diffHours}h`;
  if (diffDays < 7) return `hace ${diffDays}d`;
  return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
}

function StatusDot({ status }: { status: string }) {
  if (status === 'completed') {
    return <span className="inline-block h-2 w-2 rounded-full bg-green-500" />;
  }
  if (status === 'processing') {
    return <span className="inline-block h-2 w-2 rounded-full bg-amber-500 animate-pulse" />;
  }
  return <span className="inline-block h-2 w-2 rounded-full bg-gray-400" />;
}

export function ActivityFeed({ memories }: ActivityFeedProps) {
  if (!memories || memories.length === 0) {
    return (
      <div className="py-8 text-center text-[14px] font-light text-[#9d9c9c]">
        No hay actividad reciente
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-100">
      {memories.map((memory) => (
        <div key={memory.slug} className="flex items-center gap-3 py-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-50">
            <Film className="h-4 w-4 text-[#9d9c9c]" />
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-[14px] font-light text-[#1e1e1e] truncate">
                {memory.client_name || 'Cliente'}
              </span>
              <StatusDot status={memory.status} />
            </div>
            <p className="text-[12px] font-light text-[#9d9c9c]">
              {formatRelativeTime(memory.created_at)}
            </p>
          </div>

          {memory.video_views > 0 && (
            <div className="flex items-center gap-1 text-[12px] font-light text-[#9d9c9c]">
              <Eye className="h-3 w-3" />
              {memory.video_views}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
